import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IDeleteDepartmentInput {
    department_id: string;
}
export interface IDeleteDepartmentOutput {
    status: number;
    desc: string;
}
export const deleteDepartment = (data: IDeleteDepartmentInput): Promise<IDeleteDepartmentOutput> => {
    return fetchData(Api.DELTE_DEPARTMENT, data).then((res: IResponse<IDeleteDepartmentOutput>) => {
        return res.data;
    });
};
